__turbopack_context__.v({
  "className": "inter_abd3bae1-module__mqx1yG__className",
  "variable": "inter_abd3bae1-module__mqx1yG__variable",
});
